
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface TiktokAdsSectionProps {
  tiktokPixelId: string;
  setTiktokPixelId: (value: string) => void;
  tiktokApiToken: string;
  setTiktokApiToken: (value: string) => void;
  isEditing: boolean;
  isPixelEnabled?: boolean;
  setIsPixelEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const TiktokAdsSection: React.FC<TiktokAdsSectionProps> = ({
  tiktokPixelId,
  setTiktokPixelId,
  tiktokApiToken,
  setTiktokApiToken,
  isEditing,
  isPixelEnabled = true,
  setIsPixelEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">TikTok Ads</h3>
        
        {isEditing && (
          <div className="flex items-center space-x-4">
            <TrackingToggle
              id="tiktok-pixel-enabled"
              label="Activer le pixel"
              checked={isPixelEnabled}
              onChange={setIsPixelEnabled}
            />
            <TrackingToggle
              id="tiktok-api-enabled"
              label="Activer l'API"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isPixelEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrackingField
          id="tiktok-pixel-id"
          label="Pixel ID"
          value={tiktokPixelId}
          onChange={setTiktokPixelId}
          isEditing={isEditing}
          placeholder="Votre Pixel ID TikTok"
          disabled={!isPixelEnabled && isEditing}
        />
        <TrackingField
          id="tiktok-api-token"
          label="API Token"
          value={tiktokApiToken}
          onChange={setTiktokApiToken}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre token API TikTok"
          disabled={(!isPixelEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
